import { PORTRAIT_IMAGE } from '../../../../fields'
import { getImageAssetInitialValues } from '../../helpers'

export const getInitialValues = assets => {
  return {
    [PORTRAIT_IMAGE]: assets.map(asset => getImageAssetInitialValues(asset))
  }
}
